
$(document).ready(function() {
    $('br').attr('aria-hidden', 'true');
    $('hr').attr('aria-hidden', 'true');
    $('.flickity-prev-next-button.previous svg, .flickity-prev-next-button.next svg').attr('aria-hidden','true');
    $('.flickity-prev-next-button.previous').attr('aria-label','Previous slide');
    $('.flickity-prev-next-button.next').attr('aria-label','Next slide');
    $('.slideshow .flickity-page-dots').attr('aria-hidden','true');
    $('.block-swatch.block-swatch--disabled input').attr('aria-disabled', 'true');
    setTimeout(() => {
      $('.product-list').removeAttr('tabindex');
    }, 500);
});

// External links warning
$(document).ready(function () {
  // Handle external links
  function handleExternalLinks() {
    const excludedDomains = [
      'facebook.com',
      'instagram.com',
      'tiktok.com',
      'twitter.com',
      'linkedin.com',
      'whatsapp.com',
      'pinterest.com',
      'youtube.com',
    ];

    $('a').each(function () {
      const href = $(this).attr('href');
      if (!href) return;

      let isThirdParty = false;
      let isExcluded = false;

      try {
        const linkURL = new URL(href, window.location.href);
        const linkHost = linkURL.hostname.replace(/^www\./, '');
        const currentHost = window.location.hostname.replace(/^www\./, '');

        isThirdParty = linkHost && linkHost !== currentHost;
        isExcluded = excludedDomains.some(domain => linkHost.endsWith(domain));
      } catch (e) {
        isThirdParty = false;
      }

      if (!isThirdParty || isExcluded) return;

      // Open in new tab
      $(this).attr('target', '_blank');

      // Add aria-label only if not already set
      if (!$(this).attr('aria-label')) {
        const existingText = $(this).text().trim();
        $(this).attr('aria-label', `${existingText}, This link will open in a new tab`);
      }

      // Update image alt text
      const $img = $(this).find('img, svg').first();
      if ($img.length) {
        const altText = $img.attr('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        $img.attr('alt', updatedAlt);
      }
    });
  }

  handleExternalLinks();

  // Handle email and phone number links
  function handleContactLinks() {
    $('a[href^="mailto:"], a[href^="tel:"]').each(function () {
      const href = $(this).attr('href');
      const linkText = $(this).text().trim();

      // Only add aria-label if not already set
      if (!$(this).attr('aria-label')) {
        if (href.startsWith('mailto:')) {
          $(this).attr('aria-label', `Email Address: ${linkText}`);
        } else if (href.startsWith('tel:')) {
          $(this).attr('aria-label', `Phone number: ${linkText}`);
        }
      }
    });
  }

  handleContactLinks();
});

// Empty links
$(document).ready(function () {
  $(".text-with-icons__item a").each(function () {
    // Check if the link has no text and no <img> or <svg>
    if ($.trim($(this).text()) === "" && $(this).find("img, svg").length === 0) {
      $(this).remove();
    }
  });
});

// Back to top Button Focus
$(document).ready(function() {
    $("a#back-to-top").on("click", function(e) {
        e.preventDefault();
        setTimeout(function() {
            $("div#back-header").attr("tabindex", "-1").focus();
        }, 1000); // 1 second delay
    });
});

// For Netrition fact popups accessibility
$(document).ready(function () {
  let lastFocusedButton = null;

  // Observe when modal becomes visible
  const modal = document.querySelector('.bpplpopup-modal');

  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        modal.classList.contains('is--visible')
      ) {
        // Modal is now visible, focus on it
        setTimeout(() => {
        modal.focus();    
        }, 500);
      }
    }
  });

  if (modal) {
    observer.observe(modal, { attributes: true });
  }

  // On trigger click
  $('button.popup-trigger.nfactlink').on('click', function () {
    lastFocusedButton = $(this); // store the button that opened the modal
  });

  // On close button click
  $('button.bpplpopup-modal__closebtn.button.button--primary.btn-sm').on('click', function () {
    if (lastFocusedButton) {
      setTimeout(() => {
        lastFocusedButton.focus();
      }, 500);
    }
  });

  // On Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      if (lastFocusedButton && $('.bpplpopup-modal').hasClass('is--visible')) {
        setTimeout(() => {
          lastFocusedButton.focus();
        }, 500);
      }
    }
  });
});


// Mobile Menu Accessibility
$(document).ready(function () {
  let lastTrigger = null; // store the button that opened the panel

  // When a menu button is clicked
  $('[aria-controls]').on('click', function () {
    const targetPanelId = $(this).attr('aria-controls');
    const $targetPanel = $('#' + targetPanelId);

    // Save this button as the last trigger
    lastTrigger = $(this);

    // Delay focus by 1 second (1000 ms)
    setTimeout(function () {
      const $firstFocusable = $targetPanel.find('a, button, input, [tabindex]:not([tabindex="-1"])').first();
      if ($firstFocusable.length) {
        $firstFocusable.focus();
      } else {
        // fallback: focus the panel itself
        $targetPanel.attr('tabindex', '-1').focus();
      }
    }, 500);
  });

  // When a back button is clicked
  $('.mobile-menu__back-button').on('click', function () {
    if (lastTrigger) {
      // Delay focus back by 1 second
      setTimeout(function () {
        lastTrigger.focus();
      }, 500);
    }
  });
});

$(document).ready(function () {
    setTimeout(function () {
        $(".product-item").each(function () {
            // Exact selector for your title link
            const productTitleLink = $(this).find("a.product-item__title.text--strong.link");
            if (productTitleLink.length) {
                const productName = productTitleLink.text().trim();
                // Add aria-label to product title
                productTitleLink.attr("aria-label", productName);
                // Add aria-label to Add to Cart / View Details buttons
                $(this).find(".product-item__action-button").each(function () {
                    const btnText = $(this).text().trim();
                    $(this).attr("aria-label", btnText + " – " + productName);
                });
            }
        });
    }, 1000); // 1 second delay
});


if (window.innerWidth >= 1024) {   // desktop only
    document.querySelectorAll("button.footer__title.heading.h6").forEach(btn => {
        
        // Create a new div
        const div = document.createElement("h2");
        div.className = btn.className;          // copy classes
        div.innerHTML = btn.innerHTML;          // copy content

        // Remove aria-expanded if exists
        div.removeAttribute("aria-expanded");

        // Replace button with div
        btn.replaceWith(div);
    });
}
$(document).ready(function () {
    // On load: initialize state based on aria-expanded
    $('.faq__question').each(function () {
        const btn = $(this);
        const targetID = btn.attr('aria-controls');
        const answer = $('#' + targetID);
 
        if (btn.attr('aria-expanded') === 'false') {
            answer.css({
                height: '0',
                overflow: 'hidden',
                display: 'none'
            });
        } else {
            answer.css({
                height: 'auto',
                overflow: 'hidden',
                display: 'block'
            });
        }
    });
 
    // On click handler
    $('.faq__question').on('click', function () {
        const btn = $(this);
        const targetID = btn.attr('aria-controls');
        const answer = $('#' + targetID);
 
        // Wait for aria-expanded to update
        const checkAria = setInterval(function () {
            const isExpanded = btn.attr('aria-expanded') === 'true';
 
            if (isExpanded) {
                // OPENING
                answer.css('display', 'block');   // must be visible before measuring
 
                // Prepare for animation
                answer.css('height', 'auto');
                const autoHeight = answer.prop('scrollHeight') + "px";
 
                // Start from 0 → expand
                answer.css('height', '0');
                setTimeout(() => {
                    answer.css('height', autoHeight);
                }, 10);
 
                clearInterval(checkAria);
 
            } else if (!isExpanded) {
                // CLOSING
                const currentHeight = answer.prop('scrollHeight') + "px";
 
                // Start from current height → 0
                answer.css('height', currentHeight);
 
                setTimeout(() => {
                    answer.css('height', '0');
                }, 10);
 
                // After animation ends → hide display  
                setTimeout(() => {
                    answer.css('display', 'none');
                }, 300); // match CSS transition duration
 
                clearInterval(checkAria);
            }
 
        }, 10);
    });
 
});

document.addEventListener("DOMContentLoaded", function () {

  setTimeout(function () {

    // Facebook
    const facebookLink = document.querySelector('a[href="https://www.facebook.com/Netrition/"]');
    if (facebookLink && !facebookLink.hasAttribute("aria-label")) {
      facebookLink.setAttribute("aria-label", "Visit our Facebook page, this link will open in a new tab");
    }

    // Instagram
    const instagramLink = document.querySelector('a[href="https://www.instagram.com/netrition"]');
    if (instagramLink && !instagramLink.hasAttribute("aria-label")) {
      instagramLink.setAttribute("aria-label", "Visit our Instagram profile, this link will open in a new tab");
    }

    // Twitter
    const twitterLink = document.querySelector('a[href="https://twitter.com/netrition"]');
    if (twitterLink && !twitterLink.hasAttribute("aria-label")) {
      twitterLink.setAttribute("aria-label", "Visit our Twitter profile, this link will open in a new tab");
    }

  }, 500);

});

